import { useEffect, useLayoutEffect } from "react";
const useSafeLayoutEffect = globalThis?.document ? useLayoutEffect : useEffect;
export { useSafeLayoutEffect as t };
